/**
 * Feature detail names and capability actions of the RBAC effective-permissions contract
 * (GET /api/permissions/effective, POST /api/permissions/authorize). Checks evaluate the
 * response matrix directly: access, all_items, and the capability action groups
 * ("main.actions", "actions").
 */
export enum FeatureDetail {
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  ADMIN_STUDIO = 'ADMIN_STUDIO',
  CORE_PROJECT = 'CORE_PROJECT',
  CORE_WORKSPACE = 'CORE_WORKSPACE',
  CORE_COMPANY = 'CORE_COMPANY',
  CORE_BRAND = 'CORE_BRAND',
  CORE_CAMPAIGN = 'CORE_CAMPAIGN',
  // Audiences per type (conv.public, conv.internal, conv.group, conv.direct, ...); read by
  // @mtm/drive's audience manager through DriveConversationPermissionsService.
  CORE_CONVERSATION = 'CORE_CONVERSATION',
}

export const PermissionAction = {
  // No READ verb: the contract dropped it (2026-08-31) — readability is the feature's access flag
  // (PermissionService.hasFeatureAccess), not a capability action.
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE_USERS: 'manage.users',
  LOGIN: 'login',
  // Per-item batch response only (POST /api/permissions/items/permissions): asset-approval right.
  APPROVE_ASSETS: 'approve.assets',
} as const;

export type PermissionActionValue = (typeof PermissionAction)[keyof typeof PermissionAction];
